import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const EnrollmentsReport = () => {
  return <ReportSectionPage scope="super-admin" section="course-enrollments" title="Course Enrollments Report" />;
};

export default EnrollmentsReport;
